import { cn } from "@/libs/utils";
import SearchIcon from "@/v2-components/core/icon/search-icon";
import { useGamesSearchStore } from "@/v2-components/pages/games/search/GamesSearchInput";
import Link from "next/link";
import ArrowInsertIcon from "@/v2-components/core/icon/arrow-insert-icon";
import { useTrans } from "@/utils/useTrans";
import { useGames } from "@/api/game-api";

/*
 search preview
 */
export function GamesSearchResultPreview({
  onClick,
  className,
}: {
  onClick?: () => void;
  className?: string;
}) {
  const { t } = useTrans(["games"]);
  const searchText = useGamesSearchStore((s) => s.searchText);

  // api games data
  const { data } = useGames({ filters: [], sortBy: "" });
  const games = data || [];

  const filtered = searchText
    ? games.filter((g) =>
        g.name.toLowerCase().includes(searchText.toLowerCase()),
      )
    : games;

  const isNoData = filtered.length === 0;

  const handleOnClick = () => {
    onClick?.();
  };

  if (isNoData) {
    return (
      <div className={cn("w-full", className)}>
        <div className="px-4 py-6 text-center text-coolgray-60">
          {t("No results found")}
        </div>
      </div>
    );
  }

  return (
    <div className={cn("w-full", className)}>
      {filtered.map((game, idx) => (
        <Link
          onClick={handleOnClick}
          key={game.id}
          href={`/games/experiences/${game.slug}`}
          className={cn(
            "flex w-full items-center px-4 py-3 transition hover:bg-coolgray-10",
            "gap-3",
          )}
        >
          <span className="mr-4 flex h-8 w-8 items-center justify-center rounded-full bg-coolgray-10">
            <SearchIcon className="size-4 text-coolgray-40" />
          </span>
          <span className="flex-1 text-left text-base font-400 text-coolgray-90">
            {game.name}
          </span>
          <span className="ml-auto text-coolgray-40">
            <ArrowInsertIcon className="text-coolgray-40" />
          </span>
        </Link>
      ))}
    </div>
  );
}
